import { useTranslation } from 'react-i18next';
import { Checkbox, Popover } from '@c2fo/liquidity';
import { InfoCircleIcon } from '@c2fo/liquidity/icons';
import { useReporting } from '@/reporting';
import { useOfferBuilderContext } from '../OfferBuilderContext';

export const RENEWAL_TERM_DAYS = 60;

const PreferredAutoRenewal = ({
  autoRenewal,
  setIsRenewalChecked,
}: {
  autoRenewal: boolean;
  setIsRenewalChecked: (checked: boolean) => void;
}) => {
  const { t } = useTranslation();
  const { trackEnterpriseEvent } = useReporting();
  const {
    state: { draftOfferProperties, preferredRateSelected },
  } = useOfferBuilderContext();

  if (!draftOfferProperties && !preferredRateSelected) {
    return null;
  }

  return (
    <div className="inline-flex w-full gap-1 rounded-md border border-stroke bg-canvas px-4 py-1">
      <Checkbox
        className="bg-white"
        color="secondary"
        id="preferredRenewalCheckbox"
        checked={autoRenewal}
        onChange={(e) => {
          setIsRenewalChecked(e.target.checked);
          trackEnterpriseEvent('draft-offer::auto-renewal::preferred::checkbox-toggled', {
            isChecked: e.target.checked,
            ...(draftOfferProperties && {
              draftOfferUuid: draftOfferProperties.draftOfferUuid,
              type: draftOfferProperties.offerType,
              draftType: draftOfferProperties.draftType,
            }),
          });
        }}
        aria-labelledby="preferredRenewalCheckboxLabel"
      />
      <div className="flex flex-col p-2">
        <p className="font-medium">{t('draftOffer.preferred.autoRenewalLabel')}</p>
        <div>
          <span id="preferredRenewalCheckboxLabel" className="pr-1 text-sm">
            {t('draftOffer.preferred.autoRenewal', { renewalIntervalDays: RENEWAL_TERM_DAYS })}
          </span>
          <Popover>
            <Popover.Trigger className="inline-block align-middle">
              <InfoCircleIcon className="h-4 w-4 fill-blue-500" aria-label={t('offer.autoRenew')} />
            </Popover.Trigger>
            <Popover.Content arrow className="max-w-[240px] text-center">
              {t('draftOffer.preferred.autoRenewalTooltip')}
            </Popover.Content>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default PreferredAutoRenewal;
